import React, { useState } from "react";

function Contact() {
  const [Fdata, SetFdata] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });


  const inputhandler = (e) => {
    const {name,value } = e.target;

    SetFdata((pre) => {
      return {
        ...pre,
        [name]: value,
      };
    });
  };
  const submit = (e) => {
    e.preventDefault();
    alert(`Name: ${Fdata.name}  , Email: ${Fdata.email} , Subject: ${Fdata.subject} , Message: ${Fdata.message} `)
  };
  return (
    <>
      <div className="container-fluid bg-light py-5">
        <div className="col-md-6 m-auto text-center">
          <h1 className="h1">Contact Us</h1>
          <p>
            Proident, sunt in culpa qui officia deserunt mollit anim id est
            laborum. Lorem ipsum dolor sit amet.
          </p>
        </div>
      </div>
      <div className="container py-5">
        <div className="row py-5">
          <form className="col-md-9 m-auto" onSubmit={submit}>
            <div className="row">
              <div className="form-group col-md-6 mb-3">
                <label htmlFor="inputname">Name</label>
                <input
                  type="text"
                  className="form-control mt-1"
                  id="name"
                  name="name"
                  placeholder="Name"
                  onChange={inputhandler}
                  value={Fdata.name}
                />
              </div>
              <div className="form-group col-md-6 mb-3">
                <label htmlFor="inputemail">Email</label>
                <input
                  type="email"
                  className="form-control mt-1"
                  id="email"
                  name="email"
                  placeholder="Email"
                  onChange={inputhandler}
                  value={Fdata.email}
                />
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="inputsubject">Subject</label>
              <input
                type="text"
                className="form-control mt-1"
                id="subject"
                name="subject"
                placeholder="Subject"
                onChange={inputhandler}
                value={Fdata.subject}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="inputmessage">Message</label>
              <textarea
                className="form-control mt-1"
                id="message"
                name="message"
                placeholder="Message"
                onChange={inputhandler}
                value={Fdata.message}
                rows="8"
              ></textarea>
            </div>
            <div className="row">
              <div className="col text-end mt-2">
                <button type="submit" className="btn btn-success btn-lg px-3">
                  Let’s Talk
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Contact;
